var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white_container"},[_c('div',{staticClass:"widget-container"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0"},attrs:{"src":_vm.widget_endpoint()}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }